module.exports = __webpack_public_path__ + "img/ModalBackgroundImage.d8f22143.png";